import { Cross } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    word: "Honesty",
    line: "We tell you what your roof actually needs — nothing more, nothing less.",
  },
  {
    num: "02",
    word: "Integrity",
    line: "We do the right thing, especially when no one is watching.",
  },
  {
    num: "03",
    word: "Humility",
    line: "We serve — we don't sell. Every home is someone's whole world.",
  },
  {
    num: "04",
    word: "Excellence",
    line: "Workmanship we'd sign our name to — because we do.",
  },
  {
    num: "05",
    word: "Service",
    line: "Neighbors serving neighbors. Above and beyond, every time.",
  },
];

export default function Values() {
  return (
    <section
      id="values"
      data-testid="values-section"
      className="relative border-t border-white/10 py-28 md:py-40"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <Reveal className="max-w-3xl">
          <Eyebrow>Our Foundation</Eyebrow>
          <h2 className="mt-6 font-serif text-5xl font-medium leading-[1.05] tracking-tight md:text-7xl">
            More Than a Roof.
            <br />
            <span className="italic text-gold">It's a Responsibility.</span>
          </h2>
          <p className="mt-8 max-w-xl text-sm leading-relaxed text-white/60 md:text-base">
            We believe a company should operate with honesty, integrity, humility, excellence,
            and a genuine commitment to serving others. That's not a slogan on our wall — it's
            how we show up at your door.
          </p>
        </Reveal>

        <div className="mt-20 border-t border-white/10 md:mt-28">
          {CHAPTERS.map((chapter, i) => (
            <Reveal key={chapter.num} delay={0.05}>
              <div
                data-testid={`values-chapter-${i + 1}`}
                className={`flex flex-col gap-4 border-b border-white/10 py-10 md:flex-row md:items-baseline md:gap-14 md:py-14 ${
                  i % 2 === 1 ? "md:pl-[22%]" : ""
                }`}
              >
                <span className="font-serif text-lg italic text-gold/80">{chapter.num}.</span>
                <h3 className="font-serif text-4xl font-medium tracking-tight text-white md:text-6xl">
                  {chapter.word}
                </h3>
                <p className="max-w-sm text-sm leading-relaxed text-white/55 md:ml-auto md:text-right">
                  {chapter.line}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-24 max-w-4xl md:mt-32">
          <blockquote
            data-testid="values-faith-quote"
            className="border-l-2 border-gold pl-8 md:pl-12"
          >
            <p className="font-serif text-3xl font-light italic leading-snug text-white/90 md:text-5xl">
              &ldquo;Our faith shapes the way we do business — with integrity, excellence, and a
              commitment to serve our customers and communities well.&rdquo;
            </p>
            <footer className="mt-6 text-[11px] font-bold uppercase tracking-[0.35em] text-gold">
              The Seraph Roofing Family
            </footer>
          </blockquote>
        </Reveal>

        <Reveal delay={0.15} className="mt-16">
          <div
            data-testid="collisions-323-strip"
            className="flex flex-col items-start gap-6 border border-gold/30 bg-gold/5 p-8 md:flex-row md:items-center md:p-10"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-gold/50 bg-gold/10">
              <Cross className="h-5 w-5 text-gold" />
            </span>
            <div>
              <p className="text-[11px] font-bold uppercase tracking-[0.35em] text-gold">
                Proudly built alongside Collisions 323
              </p>
              <p className="mt-3 font-serif text-xl italic text-white/80 md:text-2xl">
                &ldquo;Whatever you do, work at it with all your heart, as working for the
                Lord.&rdquo;
                <span className="ml-3 text-sm not-italic text-white/45">— Colossians 3:23</span>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
